import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const FaqSettings = () => {
  const [form, setForm] = useState({
    headerSmall: '',
    headerTitle: '',
    faqsText: '',
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      setLoading(false);
      return;
    }

    const fetchFaqs = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/admin/faqs`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const { faqs } = res.data;
        if (faqs) {
          setForm({
            headerSmall: faqs.headerSmall || '',
            headerTitle: faqs.headerTitle || '',
            faqsText: Array.isArray(faqs.items)
              ? faqs.items.map((f) => `${f.question}||${f.answer}`).join('\n')
              : '',
          });
        }
      } catch {
        // ignore
      } finally {
        setLoading(false);
      }
    };

    fetchFaqs();
  }, []);

  const updateField = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    setError('');
    setSuccess('');

    const token = localStorage.getItem('adminToken');
    if (!token) {
      setError('انتهت صلاحية الجلسة، برجاء تسجيل الدخول مرة أخرى.');
      setSaving(false);
      return;
    }

    const items = form.faqsText
      ? form.faqsText
          .split('\n')
          .map((line) => line.trim())
          .filter(Boolean)
          .map((line) => {
            const [question, answer] = line.split('||');
            return {
              question: (question || '').trim(),
              answer: (answer || '').trim(),
            };
          })
      : [];

    try {
      await axios.put(
        `${API_BASE_URL}/api/admin/faqs`,
        {
          headerSmall: form.headerSmall,
          headerTitle: form.headerTitle,
          items,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setSuccess('تم حفظ الأسئلة الشائعة بنجاح.');
    } catch (err) {
      const message = err.response?.data?.message || 'حدث خطأ أثناء الحفظ.';
      setError(message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <p>جاري تحميل الأسئلة الشائعة...</p>;
  }

  return (
    <div className="admin-section">
      <h2 className="admin-section-title">إعدادات قسم الأسئلة الشائعة</h2>
      <p className="admin-section-subtitle">
        يمكنك هنا تعديل عنوان قسم الأسئلة الشائعة وجميع الأسئلة والأجوبة التي تظهر للعملاء.
      </p>

      {error && <div className="admin-section-error">{error}</div>}
      {success && <div className="admin-section-success">{success}</div>}

      <div className="admin-field">
        <label>العنوان الصغير</label>
        <input
          type="text"
          value={form.headerSmall}
          onChange={(e) => updateField('headerSmall', e.target.value)}
          placeholder="الأسئلة الشائعة"
        />
      </div>

      <div className="admin-field">
        <label>العنوان الرئيسي</label>
        <input
          type="text"
          value={form.headerTitle}
          onChange={(e) => updateField('headerTitle', e.target.value)}
          placeholder="في نبض كير لدينا إجابات لكل استفساراتك"
        />
      </div>

      <div className="admin-field">
        <label>الأسئلة والأجوبة (كل سطر: السؤال ثم || ثم الجواب)</label>
        <textarea
          rows={10}
          value={form.faqsText}
          onChange={(e) => updateField('faqsText', e.target.value)}
          style={{ resize: 'vertical' }}
          placeholder={
            'كم تستغرق عملية تسجيل المنتجات في هيئة الغذاء والدواء؟||تختلف المدة حسب نوع المنتج (غذاء، دواء، تجميل)...\n' +
            'ما هي المتطلبات الأساسية لإصدار رخصة صناعية؟||تتطلب الرخصة الصناعية وجود سجل تجاري ساري...'
          }
        />
        <small>مثال: السؤال||الإجابة</small>
      </div>

      <div className="admin-actions">
        <button
          type="button"
          className="admin-btn-primary"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? 'جاري الحفظ...' : 'حفظ الإعدادات'}
        </button>
      </div>
    </div>
  );
};

export default FaqSettings;

